export default function HomeScreen({ onSelect, onChat, onHelp }) {
  const GOALS = [
    { icon: "🚜", label: "農機・設備を新しくしたい",     hint: "トラクター・ハウス・農機の購入・更新",   category: "設備投資" },
    { icon: "💰", label: "農業の収入を安定させたい",     hint: "天候・価格変動のリスクを減らしたい",     category: "収入安定" },
    { icon: "🌱", label: "これから農業を始めたい・継ぎたい", hint: "新規就農・親から引き継ぐ・就農資金が必要", category: "就農支援" },
    { icon: "🌿", label: "有機農業・環境農業に転換したい", hint: "農薬・化学肥料を減らしたい",             category: "環境対応" },
    { icon: "📱", label: "スマート農業・ドローンを導入したい", hint: "省力化・自動化・ICT活用",           category: "スマート農業" },
    { icon: "🏭", label: "農産物を加工・直売・輸出したい", hint: "6次産業化・直売所・ネット販売・輸出",   category: "6次産業化" },
    { icon: "📐", label: "農地・経営規模を大きくしたい",  hint: "農地を増やす・農地を借りる・規模拡大",   category: "農地活用" },
    { icon: "🔗", label: "融資・低利ローンを探したい",    hint: "農業用の有利な融資制度を知りたい",       category: "融資" },
  ];

  return (
    <div className="screen" style={{ paddingBottom:"1rem" }}>
      {/* ヘッダーメッセージ */}
      <div style={{ background:"linear-gradient(135deg,#1a4a2e,#2d6a4f)", borderRadius:14, padding:"1.1rem", marginBottom:"1.2rem", color:"#fff" }}>
        <div style={{ fontSize:"0.78rem", color:"#a7f3c0", marginBottom:"0.3rem" }}>🌾 農援へようこそ</div>
        <h2 style={{ fontSize:"1.1rem", fontWeight:800, margin:"0 0 0.4rem" }}>
          農業でやりたいことが<br/>国のお金で実現できるかもしれません
        </h2>
        <p style={{ fontSize:"0.78rem", color:"#d1fae5", margin:0, lineHeight:1.6 }}>
          「補助金」は返済不要の国・県・市のサポート制度です。<br/>
          知らないと損をしていることが多いです。
        </p>
      </div>

      <h3 style={{ fontSize:"0.95rem", fontWeight:700, color:"#333", marginBottom:"0.75rem" }}>
        今、どんなことを考えていますか？
      </h3>

      {/* やりたいこと選択 */}
      <div style={{ display:"flex", flexDirection:"column", gap:"0.5rem", marginBottom:"1rem" }}>
        {GOALS.map((g) => (
          <button
            key={g.label}
            onClick={() => onSelect(g)}
            style={{ display:"flex", alignItems:"center", gap:"0.75rem", background:"#fff", border:"1px solid #e0e0e0", borderRadius:12, padding:"0.85rem 1rem", textAlign:"left", cursor:"pointer", boxShadow:"0 1px 4px rgba(0,0,0,.06)" }}
          >
            <span style={{ fontSize:"1.5rem", minWidth:"2rem", textAlign:"center" }}>{g.icon}</span>
            <div>
              <div style={{ fontSize:"0.9rem", fontWeight:700, color:"#1a4a2e" }}>{g.label}</div>
              <div style={{ fontSize:"0.75rem", color:"#888", marginTop:"0.1rem" }}>{g.hint}</div>
            </div>
            <span style={{ marginLeft:"auto", color:"#ccc", fontSize:"1rem" }}>›</span>
          </button>
        ))}
      </div>

      {/* 農協で断られた方へ */}
      <div
        onClick={() => onChat("農協に相談したけど補助金は難しいと言われました。他に方法はありますか？")}
        style={{ background:"#fff8e1", border:"1px solid #f59e0b", borderRadius:12, padding:"0.85rem 1rem", cursor:"pointer", marginBottom:"0.75rem" }}
      >
        <div style={{ fontSize:"0.85rem", fontWeight:700, color:"#92400e" }}>😟 農協に断られた・うまくいかなかった方へ</div>
        <div style={{ fontSize:"0.75rem", color:"#78350f", marginTop:"0.2rem" }}>農協が対応しない補助金も多数あります。AIに相談してみてください。</div>
      </div>

      {/* 自由相談 */}
      <button
        onClick={() => onChat("")}
        style={{ width:"100%", background:"#f5f5f5", border:"1px solid #ddd", borderRadius:12, padding:"0.85rem", fontSize:"0.88rem", color:"#555", cursor:"pointer", fontWeight:600, marginBottom:"0.75rem" }}
      >
        💬 困っていることを自由に相談する →
      </button>

      {/* 使い方・ヘルプ */}
      <button
        onClick={onHelp}
        style={{ width:"100%", background:"none", border:"none", color:"#aaa", fontSize:"0.8rem", cursor:"pointer", padding:"0.3rem", textAlign:"center" }}
      >
        📖 詳しい使い方・よくある質問を見る
      </button>
    </div>
  );
}
